var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7068 11.293L20.9998 8.58601V4.00001C20.9998 3.44801 20.5518 3.00001 19.9998 3.00001H15.4138L12.7068 0.293006C12.3158 -0.0979941 11.6838 -0.0979941 11.2928 0.293006L8.58576 3.00001H3.99976C3.44776 3.00001 2.99976 3.44801 2.99976 4.00001V8.58601L0.292762 11.293C-0.0982383 11.684 -0.0982383 12.316 0.292762 12.707L2.99976 15.414V20C2.99976 20.552 3.44776 21 3.99976 21H8.58576L11.2928 23.707C11.4878 23.902 11.7438 24 11.9998 24C12.2558 24 12.5118 23.902 12.7068 23.707L15.4138 21H19.9998C20.5518 21 20.9998 20.552 20.9998 20V15.414L23.7068 12.707C24.0978 12.316 24.0978 11.684 23.7068 11.293ZM8.49976 7.00001C9.32776 7.00001 9.99976 7.67201 9.99976 8.50001C9.99976 9.32801 9.32776 10 8.49976 10C7.67176 10 6.99976 9.32801 6.99976 8.50001C6.99976 7.67201 7.67176 7.00001 8.49976 7.00001ZM15.4998 17C14.6718 17 13.9998 16.328 13.9998 15.5C13.9998 14.672 14.6718 14 15.4998 14C16.3278 14 16.9998 14.672 16.9998 15.5C16.9998 16.328 16.3278 17 15.4998 17ZM7.99976 17.414L6.58576 16L15.9998 6.58601L17.4138 8.00001L7.99976 17.414Z",
    fill: "#E0B23B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: -0.000488281,
    y: -0.000244141,
    width: 24.0005,
    height: 24.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.29b24592.svg";
export { ForwardRef as ReactComponent };